<nav class="breadcrumbs" aria-label="Breadcrumb">
  <ol>
    <li *ngFor="let item of items; let last = last">
      <a *ngIf="item.link && !last" [routerLink]="item.link">{{ item.label }}</a>
      <span *ngIf="!item.link || last" [class.active]="last">{{ item.label }}</span>
      <span class="sep" *ngIf="!last">›</span>
    </li>
  </ol>
</nav>
